/*
 * @Author: Luz Liu luz.liu@zoom.us
 * @Date: 2022-07-26 14:04:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-12-15 11:36:53
 * @FilePath: \async-component-ui\packages\directives\tooltip.js
 * @Description: ~
 */
import Vue from 'vue'
import Tooltip from '@zoom/zoom-ui/src/components/tooltip/index'
import { addClass } from '../utils/dom'

const template = Vue.extend(Tooltip)
const instance = new template({
  propsData: {
    popperClass: 'as-v-tooltip',
  },
}).$mount()

const bindReference = function (e) {
  const el = e.target
  const binding = el.$binding
  if (instance.referenceElm !== el) {
    if (instance.referenceElm) {
      instance.referenceElm.removeEventListener('mouseenter', onMouseenter)
      instance.referenceElm.removeEventListener('mouseleave', onMouseleave)
    }

    instance.doDestroy()
    instance.referenceElm = el
    instance.content = binding.value
    getPlacement(binding.modifiers) &&
      (instance.currentPlacement = getPlacement(binding.modifiers))
    instance.createPopper()

    el.addEventListener('mouseenter', onMouseenter)
    el.addEventListener('mouseleave', onMouseleave)

    if (!el.hasAttribute('tabIndex')) {
      el.setAttribute('tabIndex', 0)
    }

    // el.setAttribute('aria-expanded', 'false')

    el.dispatchEvent(new MouseEvent('mouseenter'))
  }
}

export default {
  name: 'tooltip',
  bind(el, binding) {
    addClass(el, 'zm-tooltip')
    addClass(el, 'as-v-tooltip')
    el.$binding = binding
    el.addEventListener('mouseenter', bindReference, false)
  },
  componentUpdated(el, binding) {
    el.removeEventListener('mouseenter', bindReference, false)
    el.$binding = binding
    el.addEventListener('mouseenter', bindReference, false)
  },
  unbind(el, binding) {
    el.$binding = binding
    el.removeEventListener('mouseenter', bindReference, false)
  },
}

function getPlacement(options) {
  const directions = ['bottom', 'top', 'right', 'left']
  let direction
  directions.forEach((dir) => {
    options[dir] && (direction = dir)
  })
  return direction
}

function onMouseenter() {
  // instance.referenceElm.removeAttribute('aria-describedby')
  // instance.referenceElm.setAttribute('aria-expanded', 'false')
  instance.show()
}

function onMouseleave() {
  instance.hide()
}
